import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link, useLocation } from 'react-router-dom'
import { ApplicationPaths } from '../../api-authorization/ApiAuthorizationConstants';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'

export default function GameCountByPlayerId({ idType, id }) {
    const { promiseInProgress } = usePromiseTracker();
    const [authenticated, setAuthenticated] = useState(false);
    const [gameCount, setGameCount] = useState(0);
    const loginPath = ApplicationPaths.Login;
    const returnUrl = window.location.href;
    const encodedReturnUrl = encodeURIComponent(returnUrl);

    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    useEffect(async () => {
                setAuthenticated(await authService.isAuthenticated());
                var ttt = await authService.getAccessToken();
                await getPlayerGameCount(idType, id, ttt);
    }, []); //Runs only on the first render
        
    const getPlayerGameCount = async (idType, id, accessToken) => {
            var headers = {
                headers: { 'Authorization': `Bearer ${accessToken}` }
            }
            trackPromise(
                axios.get('/api/chessgames/countPlayergames?idtype=' + idType + '&id=' + id, headers).then((response) => {
                    const count = response.data;
                    setGameCount(count);
                }).catch((error) => {
                    console.log(error.response.data);
                })
            )
    };

    return (

        <div>
            {(promiseInProgress === true) ?
                <Box sx={{ pt: 2, pb: 1 }}>
                    <div style={centerDivStyle}>
                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                    </div>
                </Box>
                :
                <Box sx={{ pt: 2, pb: 1 }}>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                        <Grid item xs={12} lg={4} justifyContent="flex-end">
                            <Typography variant="h6">
                                Player has {gameCount} games in MetaDB.
                            </Typography>
                        </Grid>
                        {!authenticated &&
                            <Grid item xs={12} lg={4} justifyContent="flex-end">
                                <Button fullWidth color="primary" variant="contained" component={Link} to={{ pathname: loginPath, search: '?returnUrl=' + encodedReturnUrl }}>
                                    Login to View & Download
                                </Button>
                            </Grid>
                        }
                        {!authenticated &&
                            <Grid item xs={12} lg={4} justifyContent="flex-end">
                                <Button fullWidth color="secondary" variant="contained" component={Link} to={'/Identity/Account/Register?returnUrl=/authentication/login'}>
                                    No Account? Register
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Box>        
            }
        </div>
    )
}

